export default __webpack_public_path__ + "static/media/expl-nn_11_DE.33c3d315.png";